function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PropertyEditors from './property-editor/index';
import FormSetting from './form-setting';
import WidgetProperties from './propertyRegister';
import { addWindowResizeHandler } from '@/utils/util';
import i18n from '@/utils/i18n';
import { propertyRegistered } from '@/components/form-designer/setting-panel/propertyRegister';
var COMMON_PROPERTIES = WidgetProperties.COMMON_PROPERTIES,
  ADVANCED_PROPERTIES = WidgetProperties.ADVANCED_PROPERTIES,
  EVENT_PROPERTIES = WidgetProperties.EVENT_PROPERTIES;
export default {
  name: 'SettingPanel',
  componentName: 'SettingPanel',
  mixins: [i18n],
  components: _objectSpread({
    FormSetting: FormSetting
  }, PropertyEditors),
  props: {
    designer: Object,
    selectedWidget: Object,
    formConfig: Object,
    globalDsv: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  provide: function provide() {
    var _this = this;
    return {
      isSubFormChildWidget: function isSubFormChildWidget() {
        return _this.subFormChildWidgetFlag;
      }
    };
  },
  inject: ['getDesignerConfig'],
  data: function data() {
    return {
      designerConfig: this.getDesignerConfig(),
      scrollerHeight: 0,
      activeTab: '2',
      widgetActiveCollapseNames: ['1', '3'],
      //['1', '2', '3'],
      formActiveCollapseNames: ['1', '2'],
      commonProps: COMMON_PROPERTIES,
      advProps: ADVANCED_PROPERTIES,
      eventProps: EVENT_PROPERTIES,
      showWidgetEventDialogFlag: false,
      eventHandlerCode: '',
      curEventName: '',
      eventHeader: '',
      subFormChildWidgetFlag: false
    };
  },
  computed: {
    optionModel: {
      get: function get() {
        return this.selectedWidget.options;
      },
      set: function set(newValue) {
        this.selectedWidget.options = newValue;
      }
    }
  },
  watch: {
    'designer.selectedWidget': {
      handler: function handler(val) {
        if (!!val) {
          this.activeTab = '1';
        }
      }
    },
    'selectedWidget.options': {
      //组件属性变动后，立即保存表单JSON！！
      deep: true,
      handler: function handler() {
        this.designer.saveCurrentHistoryStep();
      }
    },
    formConfig: {
      deep: true,
      handler: function handler() {
        this.designer.saveCurrentHistoryStep();
      }
    }
  },
  created: function created() {
    var _this2 = this;
    this.$on('editEventHandler', function (eventName, eventParams) {
      this.editEventHandler(eventName, eventParams);
    });
    this.designer.handleEvent('form-css-updated', function (cssClassList) {
      _this2.designer.setCssClassList(cssClassList);
    });

    //监听字段组件选中事件
    this.designer.handleEvent('field-selected', function (parentWidget) {
      _this2.subFormChildWidgetFlag = !!parentWidget && parentWidget.type === 'sub-form';
      //console.log('subFormChildWidgetFlag', this.subFormChildWidgetFlag)
    });
  },
  mounted: function mounted() {
    var _this3 = this;
    if (!this.designer.selectedWidget) {
      this.activeTab = '2';
    } else {
      this.activeTab = '1';
    }
    this.scrollerHeight = window.innerHeight - 250 + 'px';
    addWindowResizeHandler(function () {
      _this3.$nextTick(function () {
        _this3.scrollerHeight = window.innerHeight - 250 + 'px';
        //console.log(this.scrollerHeight)
      });
    });
  },
  methods: {
    hasPropEditor: function hasPropEditor(propName, editorName) {
      if (!editorName) {
        return false;
      }

      /* alert组件注册了两个type属性编辑器，跳过第一个type属性编辑器，只显示第二个alert-type属性编辑器！！ */
      if (propName.indexOf('-') <= -1) {
        var uniquePropName = this.selectedWidget.type + '-' + propName;
        if (propertyRegistered(uniquePropName)) {
          return false;
        }
      }
      var originalPropName = propName.replace(this.selectedWidget.type + '-', ''); //去掉组件名称前缀-，如果有的话！！
      return this.designer.hasConfig(this.selectedWidget, originalPropName);
    },
    getPropEditor: function getPropEditor(propName, editorName) {
      var originalPropName = propName.replace(this.selectedWidget.type + '-', ''); //去掉组件名称前缀-，如果有的话！！
      var ownPropEditorName = "".concat(this.selectedWidget.type, "-").concat(originalPropName, "-editor");
      //console.log(ownPropEditorName, this.$options.components[ownPropEditorName])
      if (!!this.$options.components[ownPropEditorName]) {
        //局部注册的属性编辑器组件
        return ownPropEditorName;
      }
      return !!this.$root.$options.components[ownPropEditorName] ? ownPropEditorName : editorName; //全局注册的属性编辑器组件
    },
    showCollapse: function showCollapse(propsObj) {
      var result = false;
      for (var propName in propsObj) {
        if (!propsObj.hasOwnProperty(propName)) {
          continue;
        }
        if (this.hasPropEditor(propName, propsObj[propName])) {
          result = true;
          break;
        }
      }
      return result;
    },
    editEventHandler: function editEventHandler(eventName, eventParams) {
      this.curEventName = eventName;
      this.eventHeader = "".concat(this.optionModel.name, ".").concat(eventName, "(").concat(eventParams.join(', '), ") {");
      this.eventHandlerCode = this.selectedWidget.options[eventName] || '';

      // 设置字段校验函数示例代码
      if (eventName === 'onValidate' && !this.optionModel['onValidate']) {
        this.eventHandlerCode = "  /* sample code */\n  /*\n  if ((value > 100) || (value < 0)) {\n    callback(new Error('error message'))  //fail\n  } else {\n    callback();  //pass\n  }\n  */";
      }
      this.showWidgetEventDialogFlag = true;
    },
    saveEventHandler: function saveEventHandler() {
      var codeHints = this.$refs.ecEditor.getEditorAnnotations();
      var syntaxErrorFlag = false;
      if (!!codeHints && codeHints.length > 0) {
        codeHints.forEach(function (chItem) {
          if (chItem.type === 'error') {
            syntaxErrorFlag = true;
          }
        });
        if (syntaxErrorFlag) {
          this.$message.error(this.i18nt('designer.setting.syntaxCheckWarning'));
          return;
        }
      }
      this.selectedWidget.options[this.curEventName] = this.eventHandlerCode;
      this.showWidgetEventDialogFlag = false;
    }
  }
};